export function getTiktokProfileURL(username: string): string {
  return `https://tiktok.com/@${username}`
}

export function getTiktokVideoURL(username: string, videoId: string): string {
  return `${getTiktokProfileURL(username)}/video/${videoId}`
}
